module.exports = __webpack_public_path__ + "img/下对齐.af7d0c8a.svg";